module.exports = __webpack_public_path__ + "img/pc-subtitle.2fb43aa0.webp";